export default __webpack_public_path__ + "static/media/machine-icon.f368c248.svg";